window.bootstrap = require('bootstrap');

require('./utilities');
